"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertSlots = void 0;
const wrapper_1 = require("@/app/shared/pages/wrapper");
const actions_1 = require("@/wrapper/actions");
async function InsertSlots(payload, dialogRef) {
    const htmlToAdd = wrapper_1.SpotsWidgetRenderer.renderHTML(payload);
    const userBody = await (0, actions_1.getBody)();
    await (0, actions_1.setBodyHTML)(userBody.body + htmlToAdd);
    if (dialogRef.current)
        dialogRef.current.close();
}
exports.InsertSlots = InsertSlots;
